<template>
  <!-- TESTIMONIAL BIG BLUE QUOTES SLIDER -->

  <section
    class="blue-testimonials mx-auto mt-[145px] flex max-w-[1280px] justify-between lg:bg-cover lg:p-[40px] xl:h-[440px]"
  >
    <div class="my-auto">
      <img
        :src="$filters.media_path('/images/testimonial-arrow-left.svg')"
        alt=""
        class="w-[60px]"
      />
    </div>

    <div
      class="relative mx-auto h-[350px] w-[940px] rounded-t-[10px] bg-white shadow-2xl lg:pt-0"
    >
      <div class="mx-[10px]">
        <img
          :src="
            $filters.media_path('/images/quotes-testimonial-platforma-blue.png')
          "
          alt=""
          class="mx-auto mt-[30px] ml-[30px]"
        />

        <h6
          class="my-auto mx-[10px] mt-[20px] w-full text-sm italic leading-[35px] text-[#292d34] md:text-[20px] lg:mx-auto xl:w-[650px]"
        >
          Platforma had the best automation features that I had seen, and it is
          highly intuitive… A real perfect mix of human and technology.
        </h6>
      </div>

      <div
        class="place-self-bottom absolute bottom-0 flex h-[55px] w-full border-t border-[#b9bec752] bg-[#FAFBFC]"
      >
        <img
          :src="$filters.media_path('/images/tc-testimonial.svg')"
          alt=""
          class="my-auto ml-[20px] h-[35px] w-[35px]"
        />

        <p class="my-auto ml-[10px] text-lg font-bold text-[#292d34]">Tim C.</p>
      </div>
    </div>

    <div class="my-auto">
      <img
        :src="$filters.media_path('/images/testimonial-arrow-right.svg')"
        alt=""
        class="h-[60px] w-[60px]"
      />
    </div>
  </section>
</template>

<script></script>

<style>
.blue-testimonials {
  background-image: url(../media/images/VS-DOTS.svg);
}
</style>
